/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';

export interface ISteps {
  stepDescription?: string;
  stepImage?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class Steps extends Component {
  private readonly stepList: ISteps[] = [
    {
      stepDescription:
        'Cra-Z-Art Crayons<br/>Veggie Peeler<br/>Medium sized bowl<br/>Clear glue<br/>Baking soda<br/>Saline Solution<br/>Airtight Container',
      stepImage: 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZXP',
    },
    {
      stepDescription:
        'Let’s start by unwrapping the crayons you want to use—the brighter, the better—and peeling them with a veggie peeler (we suggest adult supervision for this step.)',
      stepImage: 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Ur8',
    },
    {
      stepDescription:
        'Pour the clear glue into a medium sized bowl then add 1/2 teaspoon of baking soda and 2/3 cup of saline solution to the mix and stir thoroughly with a fork.',
      stepImage: 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZXR',
    },
    {
      stepDescription:
        'Toss in the crayon flakes and stir again. Hand-mix your slime until it becomes stretchy.',
      stepImage: 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1ZXQ',
    },
    {
      stepDescription:
        'Your colorful slime is all ready for play! When they’re finished, store the slime in an airtight container to keep it fresh, gooey and stretchy!',
      stepImage: 'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1Ur7',
    },
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <h5 className='diy-small-heading-padding0'>What You’ll Need:</h5>

          {this.stepList.map((item) => (
            <React.Fragment>
              <div className='col-lg-12 col-md-12'>
                <div className='step-text'>
                  <p>{ReactHtmlParser(item.stepDescription)}</p>
                </div>
              </div>
              <div className='col-lg-12 col-md-12'>
                <div className='step-image'>
                  <img
                    className='img-responsive'
                    src={item.stepImage}
                    alt='bay doll sleeping bag'
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </React.Fragment>
    );
  }
}

export default Steps;
